/* 于禁（字文則） */
import { SG } from '../../core/kit.ts';
import { defineHero, P, S } from '../define.ts';

export default defineHero({
  id: 'yujin', name: '于禁', sub: '字文則', faction: 'wei', role: '戰士', weapon: 'spear', // 2026-10-06：能與張飛、馬超單挑的將軍，改戰士（技能不動）
  look: { beard: 'goatee', eye: 'narrow', fx: '#9fc2ff', c: { plume: '#26335f' } },
  skills: [
    ['木精召喚', 'summon', '在指定地點喚醒一株不會移動的木精守衛 {20/25/30/35} 秒（同時一株）：生命 {300/400/500/600}、攻擊 {20/28/36/44}，射程 380；木精附近 420 內的草叢與隱身單位都看得見。', { x: { k: 'treant', hp: [300, 400, 500, 600], atk: [20, 28, 36, 44], dur: [20, 25, 30, 35], still: true, range: 380, max: 1, beast: 'treant', col: '#8fd468', name: '木精' }, aim: P(560, 40), cd: [40, 35, 30, 25], mp: [60, 70, 80, 90], el: 'earth' }],
    ['風精召喚', 'command', '附近友軍移速 +{15/30/45/60}%，持續 {8/10/12/14} 秒。', { x: { k: 'buff', to: 'near', r: 400, ms: [15, 30, 45, 60], dur: [8, 10, 12, 14] }, aim: S(400) }],
    ['整飭軍紀', 'passive', '附近友軍攻擊力 +{8/13/18/23}%。', { pv: { aura: { r: 560, atkP: [8, 13, 18, 23] } } }],
    ['九天應元雷聲普化天尊', 'thunder', '對周圍每個敵人放出電流，各 {200/260/320} 傷害；敵人越多、離得越近傷害越高。', { x: { k: 'aoe', self: true, dmg: [200, 260, 320], r: 420, falloff: true, crowd: 0.25, fx: 'thunder' }, aim: S(420), cd: [150, 120, 90] }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    // 木精守衛：一般召喚物，再掛一個跟著它的眼（看得見草叢與隱身），木精倒了眼也跟著消失
    treant(u, a, X) {
      this.x_summon(u, a, X);
      const t = this.units.filter((o) => o.alive && o.summon && o.owner === u && o.name === X.name).pop();
      if (t) this.units.push(SG._sim.unit({ kind: 'ward', team: u.team, x: t.x, y: t.y, life: X.dur, r: 10, hp: 1, maxHp: 1, follow: t }));
    },
  },
});
